import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';

const routes: Routes = [
  {
    // try the home page by default
    // the auth guard will redirect to landing if there is no auth token
    // the http interceptor will redirect to login if the token is rejected
    path: '',
    redirectTo: 'tabs/home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    redirectTo: 'tabs/home',
  },
  {
    path: 'config',
    redirectTo: 'tabs/settings/config',
  },
  {
    path: 'settings',
    redirectTo: 'tabs/settings',
  },
  {
    path: 'my-account',
    redirectTo: 'tabs/settings/my-account',
  },
  {
    path: 'landing',
    loadChildren: () => import('./landing/landing.module').then( m => m.LandingPageModule)
  },
  {
    path: 'tabs',
    canActivate: [AuthGuard],
    loadChildren: () => import('./tabs/tabs.module').then( m => m.TabsPageModule)
  },
  {
    path: 'stats',
    redirectTo: 'tabs/stats',
  },
  {
    path: 'account-deleted',
    loadChildren: () => import('./auth/account-deleted/account-deleted.module').then( m => m.AccountDeletedPageModule)
  },
  {
    path: 'tesla-auth-redirect',
    loadChildren: () => import('./tesla-auth-redirect/tesla-auth-redirect.module').then( m => m.TeslaAuthRedirectPageModule)
  },
  {
    path: 'auth-redirect',
    loadChildren: () => import('./auth-redirect/auth-redirect.module').then( m => m.AuthRedirectPageModule)
  },
  {
    path: 'complete-signup',
    loadChildren: () => import('./auth/complete-signup/complete-signup.module').then( m => m.CompleteSignupPageModule)
  },
  {
    path: 'logout-redirect',
    loadChildren: () => import('./logout-redirect/logout-redirect.module').then( m => m.LogoutRedirectPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
